import React, { useContext } from "react";
import classNames from "classnames";

import Dialog from "../dialog/Dialog.jsx";

export default function Alert(props) {
  const {
    className,
    buttonText = "Ok",
    text,
    colorSecondary,
    logoSmallUrl,
    onButtonClick,
    ...rest
  } = props;
  return (
    <Dialog
      className={classNames("alert", className)}
      buttonText={buttonText}
      colorSecondary={colorSecondary}
      logoSmallUrl={logoSmallUrl}
      onButtonClick={onButtonClick}
      text={text}
      {...rest}
    />
  );
}
